import React, { memo } from 'react';

const BigPregnacy = memo(({ size = 56 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.0003 51.3333C40.887 51.3333 51.3337 40.8866 51.3337 28C51.3337 15.1134 40.887 4.66666 28.0003 4.66666C15.1137 4.66666 4.66699 15.1134 4.66699 28C4.66699 40.8866 15.1137 51.3333 28.0003 51.3333Z"
        stroke="#60B219"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.0754 27.9749C26.4697 26.3943 25.4912 24.1864 25.4912 21.7778C25.4912 16.9355 29.4052 12.9964 34.2475 12.9964C39.0898 12.9964 43.0288 16.9355 43.0288 21.7778C43.0288 25.8172 40.2439 29.2545 36.4805 30.233"
        stroke="#60B219"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.4908 21.7778C25.4908 21.7778 24.2614 17.0108 21.2507 18.19C18.6163 19.2437 19.0679 21.6523 19.6449 23.1326C20.1718 24.4875 23.7095 31.2115 21.8779 33.043"
        stroke="#60B219"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.4811 30.2581C36.4811 30.2581 36.7821 36.0788 31.7642 41.0968C26.7463 46.1147 21.6029 45.4122 18.0904 41.8996C14.5778 38.3871 15.0295 32.7419 16.0832 31.7133C16.0832 31.7133 12.0689 34.1219 10.8897 30.7598C9.71046 27.3978 13.1226 25.6667 16.033 25.6667C18.9434 25.6667 21.3019 26.7706 21.904 28.7025"
        stroke="#60B219"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6455 10.4372C12.6455 10.4372 14.2512 18.0143 19.219 20.9498"
        stroke="#60B219"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default BigPregnacy;
